export const handlePageChange = (event, value, setPagination) => {
  setPagination((prev) => ({
    ...prev,
    page: value + 1,
  }));
};

export const handleRowsPerPageChange = (event, setPagination) => {
  setPagination((prev) => ({
    ...prev,
    limit: event.target.value,
    page: 1, // Reset to first page when changing rows per page
  }));
};
